export enum I2A {
  REGATE = 'REGATE',
  ROLE_SPID_OPEX = 'OPEX',
  EXTERNAL_USER = 'externe'
}
